<template>
  <form @submit.prevent data-vv-scope="registerEmployee" autocomplete="off">
    <vs-input
      v-validate="'required|min:2|max:20|alpha'"
      data-vv-validate-on="blur"
      name="registerEmployee.first_name"
      label="Имя"
      v-model="first_name"
      autocomplete="off"
      :danger="errors.has('registerEmployee.first_name')"
      :danger-text="errors.first('registerEmployee.first_name')"
    />

    <vs-input
      v-validate="'required|email'"
      data-vv-validate-on="blur"
      type="email"
      label="Почта"
      name="registerEmployee.email"
      v-model="email"
      autocomplete="off"
      :danger="errors.has('registerEmployee.email')"
      :danger-text="errors.first('registerEmployee.email')"
    />
    <div class="mt-6">
      <vs-button type="border" @click="clear"> Очистить форму </vs-button>
      &emsp;
      <vs-button type="filled" @click="registerUser" :disabled="!validateForm">
        Зарегистрировать
      </vs-button>
    </div>
  </form>
</template>

<script>
import {
  START_EMPLOYEE_REGISTRATION_BY_COMPANY,
  BRANCH_EMPLOYEES_FETCH
} from '@/store/action.types'

export default {
  name: 'BranchRegisterEmployee',
  data() {
    return {
      first_name: '',
      email: ''
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email !== '' && this.first_name !== ''
    }
  },
  mounted() {},
  methods: {
    getErrorResponseDescription(response) {
      const error_description = response.data.error
      let notification_text
      if (
        response.status === 422 &&
        error_description === 'company not in organizator'
      ) {
        notification_text =
          'Мы обновили способ авторизации в личном кабинете. Обратитесь в поддержку для восстановления доступа к аккаунту'
      } else {
        notification_text = error_description
      }
      return notification_text
    },
    clear() {
      this.$km_track('AddEmployee', 'Click', 'Clean')
      this.first_name = ''
      this.email = ''
    },
    registerUser(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.$km_track('AddEmployee', 'Click', 'Register')
          this.$vs.loading()
          const payload = {
            branch_id: this.$route.params.id,
            first_name: this.first_name,
            email: this.email,
            notify: this.$vs.notify
          }
          this.$store
            .dispatch(START_EMPLOYEE_REGISTRATION_BY_COMPANY, payload)
            .then(() => {
              this.$store.dispatch(
                BRANCH_EMPLOYEES_FETCH,
                this.$route.params.id
              )
              this.clear()
            })
            .catch(({ response }) => {
              console.log(response)
              console.log('in catch register employee')
              this.$vs.notify({
                title: 'Не удалось зарегистрировать сотрудника',
                text: this.getErrorResponseDescription(response)
              })
            })
            .finally(() => this.$vs.loading.close())
        }
      })
    },
    onCopy() {
      this.$vs.notify({
        title: 'Успех!',
        text: 'Ссылка скопирована в буфер обмена'
      })
    },
    onError() {
      this.$vs.notify({
        title: 'Failed!',
        text: 'Error in copying text.'
      })
    }
  }
}
</script>
